import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

function OrderSuccess() {
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    const history = JSON.parse(sessionStorage.getItem("orderHistory")) || [];
    let latestOrder = history[history.length - 1];

    if (!latestOrder) {
      navigate("/shop");
      return;
    }

    // If orderNumber doesn't exist (backup fallback), assign one
    if (!latestOrder.orderNumber) {
      latestOrder.orderNumber = "#" + Math.floor(10000 + Math.random() * 90000);

      // Save updated back into history
      history[history.length - 1] = latestOrder;
      sessionStorage.setItem("orderHistory", JSON.stringify(history));
    }

    setOrder(latestOrder);
  }, [navigate]);

  if (!order) return null;

  return (
    <div className="success-page-wrapper">
      <div className="container">
        {/* SUCCESS ICON */}
        <div className="success-icon">✔</div>

        <h2 className="success-title">Order Placed Successfully!</h2>

        {/* Order Number */}
        <p className="order-number">
          Order Number: <strong>{order.orderNumber}</strong>
        </p>

        <p className="success-subtext">
          We’ve received your order and it's now being prepared.
        </p>

        {/* ORDER INFO CARD */}
        <div className="order-card">
          <h4>Order Summary</h4>

          {order.items.map((item) => (
            <div className="order-item" key={item.id}>
              <span>
                {item.name} × {item.quantity}
              </span>
              <strong>${(item.price * item.quantity).toFixed(2)}</strong>
            </div>
          ))}

          <div className="order-divider" />

          <div className="order-total">
            <span>Total Paid</span>
            <strong>${order.total.toFixed(2)}</strong>
          </div>
        </div>

        {/* SHIPPING DETAILS */}
        <div className="info-card">
          <h4>Shipping Details</h4>
          <p>
            <strong>{order.customer.name}</strong>
          </p>
          <p>{order.customer.address}</p>
          <p>
            {order.customer.city}, {order.customer.postal}
          </p>
          <p>📞 {order.customer.phone}</p>
          <p>📧 {order.customer.email}</p>
        </div>

        {/* PAYMENT METHOD */}
        <div className="info-card">
          <h4>Payment Method</h4>
          <p>
            {order.method === "cod" ? "Cash on Delivery" : "Online Payment"}
          </p>
        </div>

        {/* BUTTONS */}
        <div className="action-btns">
          <Link className="th-btn" to="/track-order">
            Track Order
          </Link>
          <Link className="th-btn style2" to="/shop">
            Continue Shopping
          </Link>
        </div>
      </div>

      {/* Styles must remain unchanged */}
      <style>{`
        .success-page-wrapper {
          padding: 70px 0;
          background: #f6f8fc;
          text-align: center;
        }
        .success-icon {
          width: 90px;
          height: 90px;
          background: #31c653;
          color: #fff;
          font-size: 48px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 20px;
          animation: popIn .4s ease-out;
        }
        @keyframes popIn {
          0% { transform: scale(0.2); opacity: 0; }
          100% { transform: scale(1); opacity: 1; }
        }
        .success-title {
          font-size: 32px;
          font-weight: 700;
          margin-bottom: 6px;
        }
        .order-number {
          background: #eaf6ff;
          display: inline-block;
          padding: 8px 18px;
          border-radius: 10px;
          margin-bottom: 15px;
          font-size: 18px;
          font-weight: 600;
          color: #0b61d6;
        }
        .success-subtext {
          color: #555;
          margin-bottom: 25px;
          font-size: 16px;
        }
        .order-card, .info-card {
          background: #fff;
          padding: 22px;
          border-radius: 14px;
          box-shadow: 0 6px 18px rgba(0,0,0,0.05);
          margin: 20px auto;
          max-width: 1200px;
          text-align: left;
        }
        .order-card h4, .info-card h4 {
          margin-bottom: 14px;
          font-size: 20px;
          font-weight: 600;
        }
        .order-item {
          display: flex;
          justify-content: space-between;
          padding: 6px 0;
        }
        .order-divider {
          border-bottom: 1px solid #ddd;
          margin: 12px 0;
        }
        .order-total {
          display: flex;
          justify-content: space-between;
          font-size: 18px;
          font-weight: 700;
        }
        .action-btns {
          margin-top: 30px;
          display: flex;
          justify-content: center;
          gap: 15px;
        }
        .th-btn {
          padding: 14px 26px;
          background: #0b61d6;
          color: #fff;
          border-radius: 10px;
          font-size: 16px;
          font-weight: 600;
          transition: .3s;
        }
        .th-btn:hover { background: #084db5; }
        .th-btn.style2 {
          background: #fff;
          border: 2px solid #0b61d6;
          color: #0b61d6;
        }
        .th-btn.style2:hover {
          background: #0b61d6;
          color: #fff;
        }
      `}</style>
    </div>
  );
}

export default OrderSuccess;
